function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
fetch(
  window.Shopify.routes.root
    + 'browsing_context_suggestions.json'
    + '?country[enabled]=true'
    + `&country[exclude]=${window.Shopify.country}`
    + '&language[enabled]=true'
    + `&language[exclude]=${window.Shopify.language}`
).then(r => r.json())
.then(r=> setCookie("countrydx", r.detected_values.country_name, 30));

document.addEventListener('DOMContentLoaded', function () { 
  setTimeout(()=> {
        var cty = getCookie("countrydx"); 
    if (cty == "United States") {
      document.querySelectorAll('.geo-us').forEach(function(el) {
         el.style.display = 'block';
      });       
      document.querySelectorAll('.geo-ca').forEach(function(el) {
         el.style.display = 'none';
      });  
      document.querySelectorAll('.geo-intl').forEach(function(el) {
         el.style.display = 'none';
      });       
    } else if (cty == "Canada") {
      document.querySelectorAll('.geo-ca').forEach(function(el) {
         el.style.display = 'block';
      });       
      document.querySelectorAll('.geo-us').forEach(function(el) {
         el.style.display = 'none';
      });  
      document.querySelectorAll('.geo-intl').forEach(function(el) {
         el.style.display = 'none';
      });   
    } else {
      document.querySelectorAll('.geo-intl').forEach(function(el) {
         el.style.display = 'block';
      });       
      document.querySelectorAll('.geo-us').forEach(function(el) {
         el.style.display = 'none';
      });  
      document.querySelectorAll('.geo-ca').forEach(function(el) {
         el.style.display = 'none';
      }); 
    }     
},900);    
});  